<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-[600px] max-h-full rounded-lg">
        <div class="relative primary-purple-light-2-background rounded-lg shadow dark:bg-gray-700 p-[25px]">
            <form #form novalidate (ngSubmit)="onSubmit()">
                <!-- Header -->
                <div class="flex items-center gap-4">
                    <div class="flex justify-between items-center w-full">
                        <h3 class="text-xl font-bold primary-purple-text dark:text-gray-400">
                            {{ literalService.get(isCreating ? 'setup.holidayCalendars.createTitle' : (isEditing ? (editingCalendar.editable ? 'setup.holidayCalendars.editTitle' : 'setup.holidayCalendars.viewTitle') : 'setup.holidayCalendars.title'), true) }}
                        </h3>
                        @if (isEditing && editingCalendar.editable && !confirmingDelete && (userRole === UserRole.SUPERADMIN || userRole === UserRole.ADMIN)) {
                            <div class="primary-purple-border px-2 py-1 flex items-center border-solid border-[1px] rounded text-sm gap-1 cursor-pointer hover:bg-gray-100" (click)="onDelete(editingCalendar)">
                                <img [src]="images.services.delete" alt="delete" class="w-[18px] h-[18px]" />
                            </div>
                        }
                    </div>
                    <button (click)="closeModal()" type="button" class="right-6 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <img [src]="images.close" class="h-6 w-6" />
                    </button>
                </div>

                <!-- Create / Edit form -->
                @if (isCreating || isEditing) {
                    <fieldset [disabled]="confirmingDelete">
                    <div class="flex flex-col mt-6">
                        <div class="flex items-center mb-[6px]">
                            <img [src]="images.setup.calendar" alt="name" class="h-5 w-5 mr-[6px]" />
                            <label class="font-normal text-base primary-purple-text">{{ literalService.get('setup.holidayCalendars.name', true) }}</label>
                        </div>
                        <input
                            type="text"
                            class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                            [value]="editingCalendar.name || ''"
                            (input)="updateName($event)"
                            [placeholder]="literalService.get('setup.holidayCalendars.namePlaceholder', true)"
                            [disabled]="isEditing && !editingCalendar.editable"
                        />
                    </div>

                    @if (showClientSelector) {
                        <div class="flex flex-col mt-4">
                            <div class="flex items-center mb-[6px]">
                                <img [src]="images.services.client" alt="client" class="h-5 w-5 mr-[6px]" />
                                <label class="font-normal text-base primary-purple-text">{{ literalService.get('setup.holidayCalendars.client', true) }}</label>
                            </div>
                            <select2
                                class="block w-full"
                                [data]="clientOptions"
                                [value]="editingCalendar.clientId"
                                [disabled]="!isCreating"
                                [placeholder]="literalService.get('setup.holidayCalendars.noClient', true)"
                                [templates]="{option: option}"
                                (update)="onClientChange($event)"
                            >
                                <ng-template #option let-label="label">
                                    <app-select2-option [label]="label" />
                                </ng-template>
                            </select2>
                        </div>
                    }

                    @if (!confirmingDelete) {
                    <div class="flex flex-col mt-4">
                        <div class="flex items-center mb-[6px]">
                            <img [src]="images.setup.calendar" alt="holidays" class="h-5 w-5 mr-[6px]" />
                            <label class="font-normal text-base primary-purple-text">{{ literalService.get('setup.holidayCalendars.holidays', true) }}</label>
                            <span class="ml-auto text-sm neutrals-grey-04-text">{{ editingHolidays.size }} {{ literalService.get('setup.holidayCalendars.selected', true) }}</span>
                        </div>

                        <div class="bg-white rounded border p-3">
                            <div class="flex items-center justify-between mb-2">
                                <button type="button" class="cursor-pointer" (click)="prevMonth()">
                                    <img [src]="images.arrowLeft" alt="prev" class="h-5 w-5" />
                                </button>
                                <span class="font-semibold capitalize">{{ monthLabel }}</span>
                                <button type="button" class="cursor-pointer" (click)="nextMonth()">
                                    <img [src]="images.arrowRight" alt="next" class="h-5 w-5" />
                                </button>
                            </div>
                            <div class="grid grid-cols-7 gap-1 text-center text-xs neutrals-grey-04-text mb-1">
                                @for (wd of weekDays; track wd) {
                                    <div class="uppercase">{{ literalService.get('calendar.weekDays.' + wd, true) }}</div>
                                }
                            </div>
                            <div class="grid grid-cols-7 gap-1">
                                @for (cell of calendarCells; track $index) {
                                    @if (cell) {
                                        <button type="button" class="aspect-square rounded text-sm" [ngClass]="(cell.selected ? 'primary text-white' : (cell.isToday ? 'primary-purple-border border-2 font-bold primary-purple-text' : 'neutrals-grey-02-background hover:bg-gray-100')) + ((isEditing && !editingCalendar.editable) ? ' cursor-default' : ' cursor-pointer')" (click)="toggleDay(cell)">
                                            {{ cell.day }}
                                        </button>
                                    } @else {
                                        <div></div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    }
                    </fieldset>
                } @else {
                    <!-- List view -->
                    <div class="flex flex-col mt-6">
                        <div class="relative mb-4">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <img [src]="images.search" class="w-5 h-5" />
                            </div>
                            <input
                                type="text"
                                class="block w-full pl-10 pr-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                                [value]="searchValue"
                                (input)="onSearchChange($event)"
                                [placeholder]="literalService.get('search', true)"
                            />
                        </div>

                        <div class="max-h-[300px] overflow-y-auto" (scroll)="$event.target && ($any($event.target).scrollHeight - $any($event.target).scrollTop - $any($event.target).clientHeight) < 50 && onScrollEnd()">
                            @for (calendar of holidayCalendars; track calendar.id) {
                                <div class="flex items-center justify-between p-2 bg-white rounded border mb-2 cursor-pointer hover:bg-gray-50" (click)="startEditing(calendar)">
                                    <div class="flex items-center gap-2 flex-1 min-w-0">
                                        <img [src]="images.setup.calendar" alt="calendar" class="h-5 w-5 shrink-0" />
                                        <span class="truncate">{{ calendar.name }}</span>
                                    </div>
                                    <div class="flex items-center gap-2 shrink-0">
                                        @if (calendar.editable) {
                                            <img [src]="images.services.edit" alt="edit" class="h-5 w-5" />
                                        } @else {
                                            <img [src]="images.viewDetail" alt="view" class="h-5 w-5" />
                                        }
                                    </div>
                                </div>
                            }
                            @if (!loading && holidayCalendars.length === 0) {
                                <div class="text-sm text-gray-500 text-center py-4">
                                    {{ literalService.get('setup.holidayCalendars.empty', true) }}
                                </div>
                            }
                        </div>
                    </div>
                }

                <!-- Inline delete confirmation -->
                @if (confirmingDelete) {
                    <div class="mt-8 pt-4">
                        <p class="text-base primary-purple-text font-semibold" [innerHTML]="literalService.get('setup.holidayCalendars.deleteConfirmText', true)"></p>
                    </div>
                    <div class="mt-8 flex items-center justify-center">
                        <button type="button" class="secondary mr-5 gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer" (click)="cancelDelete()">{{ literalService.get('cancel', true) }}</button>
                        <button type="button" class="primary gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer text-white" (click)="confirmDelete()">{{ literalService.get('confirm', true) }}</button>
                    </div>
                } @else {
                <!-- Footer Buttons -->
                <div class="flex items-center mt-8" [ngClass]="{'justify-center': isCreating || isEditing, 'justify-end': !isCreating && !isEditing}">
                    <button type="button" class="secondary mr-5 gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer" (click)="cancelEdit()" [hidden]="!isCreating && !isEditing">
                        {{ literalService.get(isEditing && !editingCalendar.editable ? 'close' : 'cancel', true) }}
                    </button>
                    <button type="submit" class="primary gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer text-white" [disabled]="!isFormValid()" [hidden]="(!isCreating && !isEditing) || (isEditing && !editingCalendar.editable)">
                        {{ literalService.get('save', true) }}
                    </button>
                    <button type="button" class="primary gap-4 px-6 py-2 border-2 font-semibold uppercase cursor-pointer text-white" (click)="startCreating()" [hidden]="isCreating || isEditing">
                        {{ literalService.get('setup.holidayCalendars.newCalendar', true) }}
                    </button>
                </div>
                }
            </form>
        </div>
    </div>
</div>
